/** Páginas Sífilis e HIV (D-060): só leitura, só situações (nenhum resultado de exame). */
import type { ClassificacaoNeonatal } from '@metaepi/shared';
import { useQuery } from '@tanstack/react-query';
import { requisitar } from '../../lib/api';

export type FaseAgravo = 'pre_natal' | 'internada' | 'pos_parto';

export const FILTRO_FASE = [
  { valor: '', rotulo: 'Todas as fases' },
  { valor: 'pre_natal', rotulo: 'Pré-natal' },
  { valor: 'internada', rotulo: 'Internada' },
  { valor: 'pos_parto', rotulo: 'Pós-parto' },
];

export type TratamentoAgravo =
  'concluido' | 'em_dia' | 'dose_pendente' | 'reiniciar' | 'nao_iniciado';
export type ParceiroAgravo =
  'nao_cadastrado' | 'pendente' | 'em_tratamento' | 'tratado' | 'nao_tratado';

interface BaseItem {
  id: string;
  paciente_id: string;
  nome: string;
  nome_social: string | null;
  unidade_nome: string;
  data_ultima_menstruacao: string | null;
  fase: FaseAgravo;
  notificacao: string | null;
}

export interface ItemSifilis extends BaseItem {
  tratamento: TratamentoAgravo;
  parceiro: ParceiroAgravo;
  recemNascidos: {
    id: string;
    nome: string | null;
    tipo_concepto: string;
    classificacao: ClassificacaoNeonatal | null;
    seguimento_id: string | null;
    seguimento: 'em_seguimento' | 'encerrado' | null;
  }[];
}

export interface ItemHiv extends BaseItem {
  tarvInicio: string | null;
  tarvRegistrada: boolean;
  recemNascidos: { id: string; nome: string | null; profilaxia: string | null }[];
}

export interface PaginaSifilisDados {
  itens: ItemSifilis[];
  contadores: {
    gestantes: number;
    tratamentoConcluido: number;
    tratamentoEmDia: number;
    tratamentoAtencao: number;
    parceiroPendente: number;
    notificacaoPendente: number;
    criancasEmSeguimento: number;
  } | null;
  precisaMunicipio: boolean;
}

export interface PaginaHivDados {
  itens: ItemHiv[];
  contadores: {
    gestantes: number;
    semTarv: number;
    notificacaoPendente: number;
    recemNascidos: number;
    recemNascidosComProfilaxia: number;
  } | null;
  precisaMunicipio: boolean;
}

export const useAgravoSifilis = () =>
  useQuery({
    queryKey: ['agravos', 'sifilis'],
    queryFn: () => requisitar<PaginaSifilisDados>('/agravos/sifilis'),
  });

export const useAgravoHiv = () =>
  useQuery({
    queryKey: ['agravos', 'hiv'],
    queryFn: () => requisitar<PaginaHivDados>('/agravos/hiv'),
  });
